import { Component } from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';

import { MessagePage } from '../message/message';
import { ProfilePage } from '../profile/profile';
import { MeetteamProvider } from '../../../providers/meetteam/meetteam';
import { AuthProvider } from '../../../providers/auth/auth';
import { MessagingProvider } from '../../../providers/messaging/messaging';


@Component({
  selector: 'page-messaging',
  templateUrl: 'messaging.html',
})
export class MessagingPage {

  showHeader:boolean = true;
  searchQuery = '';
  availableContacts: any = [];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public meetProvider: MeetteamProvider,
              private messageProvider: MessagingProvider,
              public authProvider: AuthProvider,
              private modalCtrl: ModalController) {
  }

    // Decoding image buffer
    ab2str(arraybuffer) {
      return new TextDecoder("utf-8").decode(new Uint8Array(arraybuffer))
    }

  ionViewDidLoad() {
    this.loadMessages()
    // Check if modal-header needs to show
    this.showHeader = this.authProvider.user.options.settings_social_network_enabled
  }

  loadMessages() {
    this.messageProvider.getUsers().subscribe((res) => {
      if(res.success){
        res.data.forEach(contact => {
          this.availableContacts.push([
            contact.id,
            contact.first_name,
            contact.last_name,
            contact.position,
            contact.avatar_content
          ])
        });
        console.log(this.availableContacts)
      }
    })
  }

  goToMessage(contact) {
    this.modalCtrl.create(MessagePage, {recipient: contact}).present().then(() => {});
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {}).present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/messaging/messaging.ts